export default {
    state: {
        locales: [],
    },
    mutations: {
        setLocales(state, locales) {
            state.locales = locales
        },
    },
    getters: {
        listLocales: state => state.locales,
    },
    actions: {
        loadLocales(context, cb) {
            if (context.state.locales.length > 0) {
                return
            }

            window.axios.get('/api/locales')
                .then(({data}) => {
                    context.commit('setLocales', data)
                })
                .catch(error => console.error(error))
        },
    }
}
